// NOTE: Migrating from @shopify/polaris React components to Polaris Web Components
// Toast → Custom toast component using s-banner with positioning and auto-dismiss
import React, { useEffect } from 'react';

export const ToastMarkup = ({ toast, toggleToast, content, error }) => {
    // Auto-dismiss after 3 seconds
    useEffect(() => {
        if (toast) {
            const timer = setTimeout(() => {
                toggleToast();
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [toast, toggleToast]);

    const toastMarkup = toast ? (
        <div
            style={{
                position: 'fixed',
                bottom: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 10000,
                minWidth: '320px',
                maxWidth: '500px',
                animation: 'slideUp 0.3s ease-out'
            }}
        >
            <style>{`
                @keyframes slideUp {
                    from {
                        opacity: 0;
                        transform: translateX(-50%) translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(-50%) translateY(0);
                    }
                }
            `}</style>
            <s-banner
                heading={content}
                tone={error ? "critical" : "success"}
                dismissible
                onDismiss={toggleToast}
            >
                {/* <s-stack direction="inline" gap="small" alignment="center"> */}
                    {/* <s-icon type={error ? "alert-circle" : "check-circle"} /> */}
                    {/* <s-text type="strong">{content}</s-text>
                </s-stack> */}
            </s-banner>
        </div>
    ) : null;

    return toastMarkup;
};
